import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import configureStore from './store';
import App from './App';

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { getMsalConfig } from "./config/auth365Config";
import { loadConfig } from "./config/config";
import { installFileUploadAuthInterceptor } from "./utils/FileUploadAuth";

const rootEl = document.getElementById('app-site');
export const store = configureStore();
const history = createBrowserHistory();

// สลับ Authorization ให้ request ที่ยิงไป file-manage อัตโนมัติ (ดู utils/FileUploadAuth.js)
installFileUploadAuthInterceptor();

// Load config first, then initialize app
loadConfig().then(() => {
  // Get config dynamically to ensure it uses latest localStorage values
  const msalConfig = getMsalConfig();
  const msalInstance = new PublicClientApplication(msalConfig);

  // Get basename from environment variable
  const basename = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_BASENAME)
    ? process.env.REACT_APP_BASENAME
    : 'dashboard';

  ReactDOM.render(
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <Router basename={basename}>
          <Switch>
            <Route path="/" component={App} />
          </Switch>
        </Router>
      </Provider>
    </MsalProvider>,
    rootEl
  );
});